import React from 'react';
import { Box, Button, Typography, Grid } from '@mui/material';
import { alpha } from '@mui/material/styles';

const LegendFilterGroup = ({
  title,
  items,
  selected,
  onSelect,
  showCount = false,
  getCount = () => 0,
  columns = 2,
  align = 'left',
}) => {
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Typography variant="bodyText1" ml={-1}>
        {title}
      </Typography>
      <Grid container spacing={1.5}>
        {items.map((item) => {
          const label = typeof item === 'string' ? item : item.label;
          const color = typeof item === 'string' ? null : item.color;

          return (
            <Grid item xs={12} sm={12 / columns} key={label}>
              <Button
                variant={selected === label ? 'contained' : 'outlined'}
                size="small"
                fullWidth
                onClick={() => onSelect(label)}
                sx={{
                  borderRadius: "16px",
                  justifyContent: align === 'center' ? 'center' : 'flex-start',
                  textTransform: 'none',
                  paddingLeft: align === 'center' ? 1 : 2,
                  paddingRight: 2,
                  height: 24,
                  whiteSpace: 'nowrap',
                  minWidth: 'fit-content',
                  // Selected state styles
                  ...(selected === label && {
                    backgroundColor: 'secondary.main',
                    color: 'primary.main',
                    boxShadow: '0px 4px 12px 0px rgba(74, 76, 78, 0.25)',
                    '&:hover': {
                      backgroundColor: 'secondary.dark',
                    }
                  }),
                  // Unselected state styles
                  ...(selected !== label && {
                    borderColor: 'grey.400',
                    color: 'text.primary',
                    '&:hover': {
                      borderColor: 'secondary.main',
                      backgroundColor: alpha('#94bff2', 0.1),
                    }
                  }),
                }}
              >
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent={showCount ? 'space-between' : (align === 'center' ? 'center' : 'flex-start')}
                  width="100%"
                  gap={1}
                >
                  {/* Left side: icon + label */}
                  <Box display="flex" alignItems="center" gap={1}>
                    {color && (
                      <Box
                        sx={{
                          width: 14,
                          height: 14,
                          borderRadius: '50%',
                          backgroundColor: color,
                        }}
                      />
                    )}
                    <Typography
                      variant="miniText"
                      fontSize={12}
                      fontWeight={selected === label ? 700 : 400}
                      noWrap
                    >
                      {label}
                    </Typography>
                  </Box>

                  {/* Right side: count */}
                  {showCount && (
                    <Box>
                      <Typography variant="body2" fontSize={12}>
                        <b>({getCount(label)})</b>
                      </Typography>
                    </Box>
                  )}
                </Box>
              </Button>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default LegendFilterGroup;